export default "__VITE_ASSET__bafdf6f5__"